import axios from "axios";
import React, { useState } from "react";
import closeIcon from "../../static/icons/close.png";
import minimizeIcon from "../../static/icons/window-minimize.png";
import appConfig from "../../config";
import jwtEncode from "jwt-encode";
import rightArrowIcon from "../../static/icons/right-arrow.png";
import "./Chatbot.css";

const SECRET_KEY = process.env.REACT_APP_CHAT_SECRET_KEY;

const ChatbotBox = ({
    chatData,
    setOpenChatBox,
    setChatData
}) => {
    const [step, setStep] = useState(1);

    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [finalMessage, setFinalMessage] = useState("");

    const handleChange = (event) => {
        const input = event.target.value;

        // Allow only digits
        if (!/^\d*$/.test(input)) return;

        setChatData({ ...chatData, mobile: input });

        // Validate length
        if (input.length === 0) {
            setError("Mobile number cannot be empty.");
        } else if (input.length !== 10) {
            setError("Mobile number must be exactly 10 digits.");
        } else {
            setError("");
        }
    };


    const handleRequestSubmit = async () => {

        const chatbotUrl = appConfig.chatbot[appConfig.environment].url;
        let encodedMobile = jwtEncode(chatData.mobile, SECRET_KEY);

        try {
            setIsLoading(true);

            const payload = {
                lead: {
                    mobile_no: encodedMobile,
                    message: chatData.message,
                    remarks: "customer_lead"
                },
                encoded: true
            };

            const response = await axios.post(`${chatbotUrl}`, payload, {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-localization': 'en',
                    'client-name': `${appConfig.chatbot[appConfig.environment].name}`,
                    'client-token': `${appConfig.chatbot[appConfig.environment].token}`,
                }
            });

            if (response.status) {
                //alert("Request submitted successfully");
                setStep(3);
                setFinalMessage("Thank you for reaching out! We will get back to you soon.");
                setChatData({
                    message: "",
                    mobile: ""
                });
                setTimeout(() => {
                    setOpenChatBox(false);
                }, 3000);
            } else {
                alert(`${response.message}`);
            }

        } catch (error) {
            setStep(3);
            //alert("Error submitting request, please try again later.");
            setFinalMessage("Error submitting request, please try again later.");
            console.error("Error submitting request:", error);
        } finally {
            setIsLoading(false);
        }
    }


    return (
        <div className="fixed bottom-4 right-4 chatbox-container">
            <div style={{
                width: "25rem",
                height: "25rem",
                borderRadius: "6px",
                borderWidth: "1px",
                backgroundColor: "#fff",
            }}>

                <div className="flex items-center justify-between p-4 h-[15%]">
                    <p style={{
                        fontFamily: "Moderustic",
                        fontWeight: "600",
                        fontSize: "1.4rem",
                        color: "#4165B3"
                    }}>Connect With Us</p>

                    <div className="flex items-center justify-center gap-4">
                        <img src={minimizeIcon}
                            style={{ height: "12px", width: "12px", cursor: "pointer" }}
                            onClick={() => {
                                setOpenChatBox(false);
                            }}
                            disabled={isLoading} />

                        <img src={closeIcon}
                            style={{ height: "1rem", width: "1rem", cursor: "pointer" }}
                            onClick={() => {
                                setChatData({
                                    message: "",
                                    mobile: ""
                                })
                                setOpenChatBox(false);
                            }}
                            disabled={isLoading} />
                    </div>
                </div>

                {
                    step == 1 &&
                    <div className="chat-step"
                        style={{
                            border: "1px solid #D2D2D2",
                            height: "85%",
                        }}>

                        <div
                            className="typing-bubble"
                            style={{
                                width: "80%",
                                position: "relative",
                                top: "13px",
                                left: "13px",
                                borderWidth: "1px",
                                borderTopLeftRadius: "15px",
                                borderTopRightRadius: "15px",
                                borderBottomRightRadius: "15px",
                                background: "#F2F2F2",
                                border: "1px solid #D2D2D2",
                                padding: "1rem"
                            }}>
                            <p style={{
                                color: "#7C7C7C",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                fontSize: "1.2rem",

                            }}>
                                Hi, this is our virtual assistant!
                                Tell us how we can help.
                            </p>
                        </div>

                        <div style={{
                            position: "absolute",
                            bottom: "0",
                            left: "0",
                            padding: "1rem",
                            width: "100%",
                        }}>
                            <div className="flex items-end justify-center gap-2">
                                <textarea
                                    rows="3"
                                    placeholder="Type your message here..."
                                    className="resize-none w-full p-2 border border-gray-300 rounded chatbot-textarea"
                                    style={{
                                        resize: 'none',
                                        padding: '10px',
                                        fontSize: '16px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc',
                                        minHeight: '60px',
                                    }}
                                    maxLength={150}
                                    value={chatData.message}
                                    onChange={(event) => {
                                        setChatData({
                                            ...chatData,
                                            message: event.target.value
                                        });
                                    }}
                                ></textarea>
                                {/* <input type="text"
                                    placeholder="Type your message here..."
                                    style={{ width: "100%", border: "1px solid #E0E0E0" }}
                                    value={chatData.message}
                                    onChange={(event) => {
                                        setChatData({
                                            ...chatData,
                                            message: event.target.value
                                        })
                                    }}></input> */}

                                <button
                                    onClick={() => setStep(2)}
                                    disabled={chatData.message.length === 0}
                                    title={
                                        chatData.message.length === 0
                                            ? "Please enter a message"
                                            : "Click to proceed"
                                    }
                                    style={{
                                        background: "none",
                                        border: "none",
                                        padding: 0,
                                        cursor: chatData.message.length === 0 ? "not-allowed" : "pointer"
                                    }}
                                >
                                    <img
                                        src={rightArrowIcon}
                                        style={{
                                            height: "1.5rem",
                                            width: "1.5rem",
                                            opacity: chatData.message.length === 0 ? 0.5 : 1,
                                            marginBottom: "2px"
                                        }}
                                        alt="Next"
                                    />
                                </button>

                            </div>

                        </div>

                    </div>
                }

                {
                    step == 2 &&
                    <div className="chat-step"
                        style={{
                            border: "1px solid #D2D2D2",
                            height: "85%",
                        }}>
                        <div className="flex flex-col justify-center px-[2.4rem] py-4 h-[80%]">
                            <p className="font-[Moderustic] font-semibold text-[#4A4A4A] text-[1.3rem]">
                                Please leave your Mobile Number<br />
                                So we can contact you:</p>
                            <div className="flex items-center justify-center gap-2">
                                <input
                                    type="text"
                                    className="no-arrows mt-2  px-3 py-2 border border-gray-300 rounded max-w-sm"
                                    placeholder="Enter Your Number"
                                    style={{ width: "20%" }}
                                    value={"+91"}
                                    disabled
                                ></input>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    minLength={10}
                                    maxLength={10}
                                    className="no-arrows mt-2  px-3 py-2 border border-gray-300 rounded max-w-sm chatbot-input"
                                    placeholder="Enter Your Number"
                                    style={{ width: "80%" }}
                                    value={chatData.mobile}
                                    onChange={handleChange}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();

                                            if (chatData.mobile.length !== 0 && chatData.mobile.length == 10 && !isLoading) {
                                                handleRequestSubmit();
                                            }
                                        }
                                    }}
                                ></input>
                            </div>
                        </div>

                        <div className={chatData.mobile.length === 0 || error.length > 0 || isLoading ? "bg-gray-400" : "bg-[#EE2852]"}
                            style={{
                                position: "absolute",
                                bottom: "14px",
                                left: "42px",
                                width: "80%",
                            }}>
                            <div className="flex items-center justify-center">
                                <button
                                    className={`w-full px-4 py-2 rounded-md font-[Open Sans] font-semibold transition-all duration-200 shadow-md rounded-md
                                            ${chatData.mobile.length === 0 || error.length > 0 || isLoading
                                            ? 'bg-gray-400 text-white cursor-not-allowed'
                                            : 'bg-[#EE2852] text-white hover:bg-[#d51d45]'}`}
                                    disabled={chatData.mobile.length === 0 || error.length > 0 || isLoading}
                                    title={
                                        chatData.mobile.length === 0
                                            ? "Please enter a number"
                                            : error.length > 0
                                                ? "Enter a valid number"
                                                : "Click to proceed"
                                    }
                                    onClick={handleRequestSubmit}
                                >
                                    SEND
                                </button>

                            </div>
                        </div>

                    </div>
                }

                {
                    step === 3 && (
                        <div className="chat-step bounce-in"
                            style={{
                                border: "1px solid #D2D2D2",
                                borderRadius: "12px",
                                height: "85%",
                                padding: "1.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#FAFAFA",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                                textAlign: "center"
                            }}>
                            <p style={{
                                fontFamily: "Moderustic, sans-serif",
                                fontWeight: 600,
                                color: "#4A4A4A",
                                fontSize: "1.5rem",
                                lineHeight: "1.6"
                            }}>
                                {finalMessage}
                            </p>
                        </div>
                    )
                }



            </div>
        </div >
    );
}

export default ChatbotBox;